import { BaseImage } from "@app/components/common/BaseImage/BaseImage";
import React, { useEffect, useState, useCallback, useRef } from 'react';
import { SidebarNavigationItem } from "@app/components/layouts/main/sider/sidebarNavigation";
import { RootState } from "@app/store/store";
import { canAccess } from "@app/utils/permissionUtils";
import ReportingMenuIcon from "assets/menus/temp/reporting-1.svg";
import SelectedReportingMenuIcon from "assets/menus/temp/reporting.svg";
import { GetActiveReportCategoriesByUserRoleId } from "@app/api/reports.api";

export const REPORT_MENU = (state: RootState): SidebarNavigationItem[] => {
    const reportMenus = state.reportMenus.reportMenus || [];
    const areacode = process.env.REACT_APP_CURRENT_LOCALITY ? process.env.REACT_APP_CURRENT_LOCALITY : "WA";
    const [isHideReportMenu, setIsHideReportMenu] = useState(true);

    // useEffect(() => {
    //     checkHideReportMenuSetting();
    // }, []);

    // const checkHideReportMenuSetting = async (
    // ) => {
    //     try {
    //         const response = await GetActiveReportCategoriesByUserRoleId(
    //         ).then((res) => {
    //             if(res.data.length > 0)
    //             {
    //                 setIsHideReportMenu(false);
    //             }
    //             else
    //             {
    //                 setIsHideReportMenu(true);
    //             }
    //         });
    //     } catch (error) {
    //         console.error('Error fetching data:', error);
    //     }

    // };
    // generate child menus with report menus
    // const childMenus: SidebarNavigationItem[] = reportMenus.map((reportMenu) => ({
    //     title: reportMenu.name,
    //     key: `report_menu_${reportMenu.Id}`,
    //     icon: <DoubleRightOutlined />,
    //     url: `/reports/${reportMenu.Id}`,
    // }));

    return [{
        title: 'common.reports',
        key: 'reports',
        icon: <BaseImage src={ReportingMenuIcon} preview={false} />,
        selectedIcon: <BaseImage src={SelectedReportingMenuIcon} preview={false} />,
        url: '/reports/categories',
        show: canAccess(state, 'report.view') 

        // children: childMenus,
    }];
}